/* tslint:disable */
/* eslint-disable */
/**
 * Project Freelancer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ClientTermsResource
 */
export interface ClientTermsResource {
    /**
     * 
     * @type {string}
     * @memberof ClientTermsResource
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof ClientTermsResource
     */
    url: string;
}

/**
 * Check if a given object implements the ClientTermsResource interface.
 */
export function instanceOfClientTermsResource(value: object): value is ClientTermsResource {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('url' in value) || value['url'] === undefined) return false;
    return true;
}

export function ClientTermsResourceFromJSON(json: any): ClientTermsResource {
    return ClientTermsResourceFromJSONTyped(json, false);
}

export function ClientTermsResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClientTermsResource {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'url': json['url'],
    };
}

export function ClientTermsResourceToJSON(value?: ClientTermsResource | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'url': value['url'],
    };
}

